/**
 * The sidebar's "Security (2)" count, as something a page can tell the shell about.
 *
 * The shell polls the count every minute; the Security page knows the exact number the moment it loads
 * or releases a lockout, and releasing the last one should clear the amber label in the same click
 * rather than up to a minute later. The page reports it here and the shell listens - the port of the
 * static `LockoutsViewModel.CountChanged` event, which carried the count for the same reason: the
 * listener has no need to re-fetch what the caller already has.
 */
type Listener = (count: number) => void;

const listeners = new Set<Listener>();

/** Returns the unsubscribe. */
export function onLockoutCount(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function reportLockoutCount(count: number): void {
  for (const listener of listeners) listener(count);
}
